// extracted by mini-css-extract-plugin
export default {"button":"styles_button__pLjqO","selected":"styles_selected__nzOWA"};